export default "__VITE_ASSET__Drh5mUol__"